import React from "react";
import { FolderIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type GoogleDriveFolderRowProps = {
  id: string;
  name: string;
  onOpen: (id: string, name: string) => void;
  onHover?: (id: string) => void;
};

export const GoogleDriveFolderRow = React.memo(function GoogleDriveFolderRow({
  id,
  name,
  onOpen,
  onHover,
}: GoogleDriveFolderRowProps) {
  return (
    <button
      type="button"
      className={cn(
        "flex w-full items-center gap-2 rounded-md px-2 py-2 text-left text-sm",
        "hover:bg-muted/60 transition-colors"
      )}
      onClick={() => onOpen(id, name)}
      onMouseEnter={() => onHover?.(id)}
      data-testid={`drive-folder-${id}`}
    >
      <FolderIcon className="h-4 w-4 shrink-0 text-amber-500" />
      <span className="truncate font-medium">{name}</span>
    </button>
  );
});
